import React from "react";
import Routes from "./Routes";
import Header from "./Header";
import Footer from "./Footer";
import "./App.css";

/**
 * dpndon.io app.
 */
function App() {
  return (
    <div className="app">
      <Header />
      <main className="app-content">
        <Routes />
      </main>
      <Footer />
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js